module.exports = __webpack_public_path__ + "img/lengquefa-on.609f4d51.png";